import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MdcService } from '../shared/mdc/mdc.service';
import { PaisService } from '../shared/pais/pais.service';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { InqueritoService } from '../shared/inquerito/inquerito.service';
import { AuthService } from '../shared/auth/auth.service';
import { LanguageService } from '../shared/language/language.service';
import { Capacitor } from '@capacitor/core';
import { Inquerito } from '../shared/inquerito/inquerito.model';
import { Subscription } from 'rxjs';
import { CountdownService } from '../shared/countdown/countdown.service';

declare var Swal: any;

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('headerMenu') headerMenu!: ElementRef;

  menuOpen = false;
  isXlScreen = false;
  showHeader: boolean = true;
  lang: string = '';
  languages = [
    { name: 'Português', code: 'pt', flag: 'caboverde.svg' },
    { name: 'English', code: 'en', flag: 'english.png' },
    { name: 'Français', code: 'fr', flag: 'french.png' }
  ];

  status: string = '';
  remainingTime: string = '';
  prefixMessage: string = '';
  private subs = new Subscription();

  constructor(private translateService: TranslateService,
    public mdcService: MdcService,
    public paisService: PaisService,
    private router: Router,
    public authService: AuthService,
    private countdownService: CountdownService,
    public languageService: LanguageService) {
  }

  // @HostListener('window:resize', ['$event'])
  // onResize() {
  //   this.checkScreenSize();
  // }

  ngAfterViewInit(): void {
    this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.showHeader = event.url !== '/';
      this.lang = localStorage.getItem('lang') || 'pt';
    });
  }

  ngOnInit(): void {
    this.lang = localStorage.getItem('lang') || 'pt';

    this.subs.add(
      this.countdownService.remainingTime$.subscribe(time => {
        this.remainingTime = time;
      })
    );

    this.subs.add(
      this.countdownService.prefixMessage$.subscribe(message => {
        this.prefixMessage = message;
      })
    );

    this.subs.add(
      this.countdownService.status$.subscribe(status => {
        this.status = status;
      })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  toggleLanguageDropdown() {
    this.languageService.languageDropdownOpen = !this.languageService.languageDropdownOpen;
  }

  changeLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    //console.log(lang)
    this.translateService.use(lang);
    this.mdcService.loadForm();
    //this.mdcService.getLabelByLang(lang);
    //this.paisService.getPaisesEstrangeiros(lang);
    //this.mdcService.getMdcOptions(lang);
    //this.mdcService.getAtividadesByLang(lang);
    this.mdcService.formData.mdc_11 = [];
    this.mdcService.formData.mdc_30 = [];
    this.mdcService.formData.mdc_33 = [];
    this.mdcService.formData.mdc_34 = [];
    this.mdcService.formData.mdc_38 = [];
    this.lang = lang;
    this.languageService.languageDropdownOpen = false;
  }

  getLanguageFlag(code: string) {
    const language = this.languages.find(l => l.code === code);
    return language ? language.flag : '';
  }

  isNotWeb(): boolean {
    if (Capacitor.getPlatform() !== 'web') {
      return true;
    } else {
      return false;
    }
  }

  logout(): void {
    Swal.fire({
      title: "Terminar sessão!",
      text: "Tem certeza que pretende terminar a sessão?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Confirmar"
      // @ts-ignore
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });

  }

  toggleMenu(event: MouseEvent) {
    event.preventDefault();
    this.menuOpen = !this.menuOpen;

    if (!this.isXlScreen) {
      this.menuOpen = !this.menuOpen;
    } else {
      if (this.menuOpen) {
        this.headerMenu.nativeElement.style.display = 'block';
        setTimeout(() => {
          this.headerMenu.nativeElement.classList.add('nk-sidebar-active');
        }, 10);
      } else {
        this.headerMenu.nativeElement.classList.remove('nk-sidebar-active');
        setTimeout(() => {
          if (!this.menuOpen) {
            this.headerMenu.nativeElement.style.display = 'none';
          }
        }, 300);
      }
    }
  }

  checkScreenSize() {
    this.isXlScreen = window.innerWidth >= 992;

    if (this.isXlScreen) {
      this.menuOpen = true;
    }
  }
}
